(function () {
  const triggers = document.querySelectorAll('.ntf-discount-info-trigger');
  if (!triggers.length) return;

  let activeModal = null;
  let lastFocused = null;

  function openModal(modal, triggerEl) {
    if (!modal) return;
    activeModal = modal;
    lastFocused = triggerEl || document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ntf-modal-open');
    const closeBtn = modal.querySelector('.ntf-discount-modal__close');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal() {
    if (!activeModal) return;
    activeModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ntf-modal-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
    activeModal = null;
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeModal();
  }

  triggers.forEach((t) => {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = t.getAttribute('data-ntf-modal-target') || 'ntf-discount-modal';
      const modal = document.getElementById(targetId);
      openModal(modal, t);
    });
  });

  document.querySelectorAll('[data-ntf-modal-close]').forEach((el) => {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeModal();
    });
  });
})();